import { getTenantTerminationMinimumDate } from 'parkchirp-shared/tenant-termination';
import { dayjs } from '../../utils/dayjs';

type Subscription = {
	tenantEnforceTermination: boolean;
	billingProfile: {
		terminationRule: string | null;
		terminationNoticeDay: number | null;
		facility: { timezone: string };
	};
};

export function getTenantTerminationState({
	isTenant,
	subscription,
	loading,
	error,
	terminationDate,
}: {
	isTenant: boolean;
	subscription?: Subscription | null;
	loading: boolean;
	error?: unknown;
	terminationDate?: string | null;
}) {
	if (!isTenant) return { disabled: false, minimumDate: null, errorMessage: null };
	if (
		loading ||
		error ||
		!subscription?.billingProfile?.facility?.timezone ||
		typeof subscription.tenantEnforceTermination !== 'boolean' ||
		(subscription.tenantEnforceTermination && !subscription.billingProfile.terminationRule)
	) {
		return {
			disabled: true,
			minimumDate: null,
			errorMessage: loading
				? null
				: 'Unable to load termination rules. Refresh the page before terminating parkers.',
		};
	}
	const { billingProfile, tenantEnforceTermination } = subscription;
	let minimumDate: string;
	try {
		minimumDate = getTenantTerminationMinimumDate(
			{
				tenantEnforceTermination,
				terminationRule: billingProfile.terminationRule,
				terminationNoticeDay: billingProfile.terminationNoticeDay,
			},
			dayjs().tz(billingProfile.facility.timezone).format('YYYY-MM-DD'),
		);
	} catch {
		return {
			disabled: true,
			minimumDate: null,
			errorMessage: 'Termination settings are invalid. Please contact your parking administrator.',
		};
	}
	const date = dayjs(terminationDate, 'YYYY-MM-DD', true);
	return {
		minimumDate,
		disabled: !terminationDate || !date.isValid() || date.format('YYYY-MM-DD') < minimumDate,
		errorMessage: null,
	};
}
